import type { ApiError } from '@boothiva/api-client';
import { Camera } from 'lucide-react';
import { Outlet } from 'react-router';

export function AuthLayout() {
  return <main className="bv-auth-layout">
    <section className="bv-auth-brand" aria-label="Boothiva">
      <Camera aria-hidden="true" size={42} /><span className="bv-auth-brand__name">Boothiva</span>
      <h1>Make every moment worth keeping.</h1><p>One calm workspace for your photo booth business.</p>
    </section>
    <section className="bv-auth-form"><div className="bv-auth-form__inner"><Outlet /></div></section>
  </main>;
}

export function AuthError({ error, fallback = 'Something went wrong. Please try again.' }: { error: unknown; fallback?: string }) {
  const apiError = error as ApiError | undefined;
  const message = apiError?.message || fallback;
  return <div className="bv-auth-alert bv-auth-alert--error" role="alert"><span>{message}</span>{apiError?.problem?.correlationId && <details><summary>Support details</summary><code>{apiError.problem.correlationId}</code></details>}</div>;
}
